window.profileRegisterForm = () => {
    return {
        action: null,

        doSearch(identifier) {
            this._resetOptions();
            this._setLoadingOption();

            fetch(this.action, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ identifier }),
            })
                .then((response) => response.json())
                .then((json) => {
                    json.items.forEach((item, index) => {
                        this.$refs.jobField.options[index] = new Option(item.label, item.value);
                    });
                })
                .catch(() => {
                    console.log("error");
                });
        },

        _resetOptions() {
            for (let i = this.$refs.jobField.options.length-1; i >= 0; i--) {
                this.$refs.jobField.options[i] = null;
            }
        },

        _setLoadingOption() {
            this.$refs.jobField.options[0] = new Option('Loading...');
        }
    }
};
